import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames/bind';

import { Icon } from '../../elements';
import styles from './ImagePicker.module.scss';
import { postImage } from '../../services';

const cx = cn.bind(styles);
const MAX_FILE_SIZE = 5242880 // in byte (5MB)

const ImagePicker = ({ label, onSelect, defaultValue, ...defaultProps }) => {
	const [fileName, setFileName] = React.useState(defaultValue ? defaultValue.name : 'Datei auswählen...');
	const [isSelected, setSelected] = React.useState(defaultValue || false);

	const handleSelect = (event) => {
		const file = event.target.files[0];
		setSelected(false);

		if (file) {
			if (file.size > MAX_FILE_SIZE) {
				alert("Die Bilddatei ist zu groß.");
			} else {
				setFileName(file.name);
				
				// Upload the file directly without compression
				postImage(file)
					.then(res => {
						setSelected(true);
						onSelect(res);
					})
					.catch(error => {
						console.error("Error uploading image:", error);
						alert("Fehler beim Hochladen des Bildes.");
					});
			}
		}
	};

	const handleDeleteImage = () => {
		setSelected(false);
		setFileName('Datei auswählen...');
		onSelect(null);
	};

	return (
		<div className={styles.wrapper}>
			<label className={styles.label}>{label}</label>
			<div className={styles.inputWrapper}>
				<input
					{...defaultProps}
					className={styles.input}
					type='file'
					accept='image/*'
					onChange={(e) => handleSelect(e)}
					aria-label='Dateien durchsuchen'
				/>
				<label className={styles.customWrapper} htmlFor={defaultProps.id}>
					<span className={cx(styles.customInput, { selected: isSelected })}>{fileName}</span>
					{!isSelected ? (
						<span className={styles.customButton}>Durchsuchen</span>
					) : (
						<button
							type='button'
							className={styles.deleteButton}
							onClick={() => handleDeleteImage()}>
							<Icon name='delete' size='24' fill='none' strokeColor='#fff' />
						</button>
					)}
				</label>
			</div>
			<Icon
				className={cx(styles.success, { show: isSelected })}
				name='circle_check'
				size='32'
				color='#20a76a'
			/>
		</div>
	);
};

ImagePicker.propTypes = {
	onSelect: PropTypes.func.isRequired,
	label: PropTypes.string,
	defaultValue: PropTypes.object,
};

export default ImagePicker;
